/**
 * @typedef {Object} SondaggioVFN
 * @property {number} idSondaggio
 * @property {number} coloreSondaggio
 */

import { delay } from "../common/functions/delay"
import ApiCore from "./ApiCore"

/**
 * @typedef {Object} CampioneVFN
 * @property {number} idCampione
 * @property {number} coloreCampione
 */

/**
 * @typedef {Object} DatoVFN
 * @property {number} idCampione
 * @property {number} idSondaggio
 * @property {number} idParametro
 * @property {string} matrice
 * @property {number} valore
 * @property {number} coloreCampione
 * @property {number} vfn
 */
 
export class VFNService extends ApiCore {

    /**
     * 
     * @param {SondaggioVFN[]} sondaggi 
     * @param {CampioneVFN[]} campioni
     * @param {DatoVFN[]} dati
     */
    constructor() {
        super()
        this.ready = false

        const p1 = this.instance.get('/parametri/vfn').then(response => {
            this.dati = response.data.vfnParametri.map(i => ({
                idCampione: i.idc,
                idSondaggio: i.ids,
                idParametro: i.idp,
                matrice: i.mat,
                valore: i.val,
                coloreCampione: i.colc,
                vfn: i.vfn
            }))
        })

        const p2 = this.instance.get('/campioni/vfn').then(response => {
            this.campioni = response.data.vfncampioni.map(i => ({
                idCampione: i.idcampione,
                coloreCampione: i.colorecampione
            }))
        })

        const p3 = this.instance.get('/sondaggi/vfn').then(response => {
            this.sondaggi = response.data.vfnsondaggi.map(i => ({
                idSondaggio: i.idsondaggio,
                coloreSondaggio: i.max_colorecampione
            }))
        })

        Promise.all([p1, p2, p3]).then(() => { this.ready = true })
    }

    async untilReady() {
        while (!this.ready) await delay(100)
    }

    /**
     * 
     * @param {number | string} id id sondaggio
     * @returns 
     */
    async coloreSondaggio(id) {
        await this.untilReady()
        return this.sondaggi.find(s => s.idSondaggio === parseInt(id))?.coloreSondaggio
    }

    /**
     * 
     * @param {number | string} id 
     * @returns 
     */
    async coloreCampione(id) {
        await this.untilReady()
        return this.campioni.find(c => c.idCampione === parseInt(id))?.coloreCampione
    }

    /**
     * 
     * @param {number | string} idSondaggio 
     * @param {number | string} idCampione 
     * @param {number | string} idParametro 
     * @param {'E' | 'T'} matrice 
     * @returns 
     */
    async vfn(idSondaggio, idCampione, idParametro, matrice) {
        await this.untilReady()
        return this.dati.find(d => (
            d.idSondaggio === parseInt(idSondaggio)) &&
            d.idCampione === parseInt(idCampione) &&
            d.idParametro === parseInt(idParametro) &&
            d.matrice === matrice
        )?.vfn
    }
}